// export const fetcher = async (url, token) => {
// 	if (url) {
// 		const res = await fetch(url, {
// 			method: "POST",
// 			headers: new Headers({"Content-Type": "application/json", token}),
// 			credentials: "include",
// 		});
//
// 		return res.json();
// 	}
// };

import axios from "axios";

const fetcher = url => axios.get(url).then(res => res.data)

export const fetchCompanies = async (url) => {
	if (url) {
		const res = await axios.get(url)
		return res.data.json();
	}
};

export const getFetcher = async (url) => {
	if (url) {
		const res = await axios.get(url)
		return res.data;
	}
};

export const postFetcher = async (url, data) => {
	if (url) {
		const res = await axios.post(url, data)
		return res.data;
	}
};
export const postMethodFetcher = async (url, data) => {
	if (url) {
		const res = await axios.post(url, data)
		return res.data;
	}
};
export const getFeedFetcher = async (url) => {
	if (url) {
		const res = await fetch(url, {
			method: "GET",
			credentials: "include",
		});

		return res.json();
	}
}

export default fetcher;
